import manufacturingImage from 'assets/sessions/manufacturing.png'
import franceImage from 'assets/sessions/france.png'
import germanyImage from 'assets/sessions/germany.png'
import healthcareImage from 'assets/sessions/healthcare.png'
import regionImage from 'assets/sessions/region.png'

export interface ISession {
  id: string // Horan - this is a horrible way to do this, but under tight deadline
  image: string
  bluejeans: string
  side: {
    category: string
    header: string
    schedule: string
    body: string
    speakers?: string[]
  }
  videoSrc: string
  posterSrc: string
}

export const Sessions: { [key: string]: ISession } = {
  manufacturing: {
    id: '9e4b328b-85b5-4393-a232-550ac67962f9',
    bluejeans: 'https://primetime.bluejeans.com/a2m/live-event/peqxurxu',
    image: manufacturingImage,
    side: {
      category: 'Breakout Session',
      header: '5G in Manufacturing',
      speakers: [],
      schedule: 'Session will begin immediately following the live stream at 3:00 pm GMT / 4:00 pm CET',
      body: 'This breakout session covers Verizon’s 5G offering for the manufacturing sector.'
    },
    videoSrc: 'https://d1oc551tl862q5.cloudfront.net/international-5g-manufacturing.mp4',
    posterSrc: manufacturingImage
  },
  healthcare: {
    id: '407b328b-85b5-4393-a232-550ac67962f9',
    bluejeans: 'https://primetime.bluejeans.com/a2m/live-event/hyvwxcja',
    image: healthcareImage,
    side: {
      category: 'Breakout Session',
      header: '5G in Healthcare',
      schedule: '',
      speakers: [],
      body: 'This breakout session covers Verizon’s 5G offering for the healthcare sector.'
    },
    videoSrc: 'https://d1oc551tl862q5.cloudfront.net/international-5g-healthcare.mp4',
    posterSrc: healthcareImage
  },
  '5gInFrance': {
    id: '4a0b328b-85b5-4393-a232-550ac67962f9',
    bluejeans: 'https://primetime.bluejeans.com/a2m/live-event/qgvvkkaz',
    image: franceImage,
    side: {
      category: 'Breakout Session',
      header: '5G in France',
      schedule: '',
      speakers: [],
      body: 'This breakout session is in the French language and covers Verizon’s 5G offering in France.'
    },
    videoSrc: 'https://d1oc551tl862q5.cloudfront.net/international-5g-france.mp4',
    posterSrc: franceImage
  },
  '5gInGermany': {
    id: '900b328b-85b5-4393-a232-550ac67962f9',
    bluejeans: 'https://primetime.bluejeans.com/a2m/live-event/udfcqjev',
    image: germanyImage,
    side: {
      category: 'Breakout Session',
      header: '5G in Germany',
      schedule: '',
      speakers: [],
      body: 'This breakout session is in the German language and covers Verizon’s 5G offering in Germany.'
    },
    videoSrc: 'https://d1oc551tl862q5.cloudfront.net/international-5g-germany.mp4',
    posterSrc: germanyImage
  },
  '5gInEmea': {
    id: '5eab328b-85b5-4393-a232-550ac67962f9',
    bluejeans: 'https://primetime.bluejeans.com/a2m/live-event/ysswbeze',
    image: regionImage,
    side: {
      category: 'Breakout Session',
      header: '5G in your Region',
      schedule: '',
      speakers: [],
      body: 'This breakout session covers Verizon’s 5G offering in EMEA with a general audience Q&A.'
    },
    videoSrc: 'https://d1oc551tl862q5.cloudfront.net/international-5g-region.mp4',
    posterSrc: regionImage
  }
}
